export var presetsTypes = {
    DEFAULT: 'DEFAULT',
    DS: 'DS',
    EDITOR: 'EDITOR',
    OOI: 'OOI',
    BOLT: 'BOLT',
    MOBILE: 'MOBILE',
};
//# sourceMappingURL=presets-types.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-presets/dist/es/presets/presets-types.js
// module id = 121
// module chunks = 0 1